import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/site/Layout';
import Home from '@/pages/Home';
import Services from '@/pages/Services';
import Work from '@/pages/Work';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import WebsiteDevelopment from '@/pages/services/WebsiteDevelopment';
import WebAppDevelopment from '@/pages/services/WebAppDevelopment';
import MobileAppDevelopment from '@/pages/services/MobileAppDevelopment';
import CustomerSolutionsDevelopment from '@/pages/services/CustomerSolutionsDevelopment';
import EcommerceWebsiteDevelopment from '@/pages/services/EcommerceWebsiteDevelopment';
import AISolutions from '@/pages/services/AISolutions';
import City from '@/pages/City';
import Pricing from '@/pages/Pricing';
import Legal from '@/pages/Legal';
import Landing from '@/pages/Landing';
import WorkDetail from '@/pages/WorkDetail';
import { WORK } from '@/data/work';
import { CITIES } from '@/data/cities';
import { LANDINGS } from '@/data/landings';
import '@/App.css';

function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="text-center">
        <div className="text-[11px] uppercase tracking-[0.28em] text-ink-muted">404</div>
        <h1 className="mt-3 text-4xl md:text-5xl font-bold tracking-tight">Lost in the file.</h1>
        <p className="mt-3 text-ink-muted">This page doesn’t exist (or isn’t built yet).</p>
        <a
          href="/"
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm hover:bg-white/[0.04]"
        >
          ← Back to home
        </a>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/website-development" element={<WebsiteDevelopment />} />
          <Route path="/services/web-app-development" element={<WebAppDevelopment />} />
          <Route path="/services/mobile-app-development" element={<MobileAppDevelopment />} />
          <Route path="/services/custom-software-development" element={<CustomerSolutionsDevelopment />} />
          <Route path="/services/ecommerce-website-development" element={<EcommerceWebsiteDevelopment />} />
          <Route path="/services/ai-solutions" element={<AISolutions />} />
          <Route path="/work" element={<Work />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/website-development-cost" element={<Pricing />} />
          <Route path="/policy" element={<Legal doc="policy" />} />
          <Route path="/tos" element={<Legal doc="tos" />} />
          {CITIES.map((c) => (
            <Route key={c.slug} path={c.path} element={<City slug={c.slug} />} />
          ))}
          {WORK.map((w) => (
            <Route key={w.slug} path={`/work/${w.slug}`} element={<WorkDetail slug={w.slug} />} />
          ))}
          {LANDINGS.map((l) => (
            <Route key={l.slug} path={l.path} element={<Landing slug={l.slug} />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
